export default function TimeOut() {
  return (
    <header className='counter'>
      <p>You ran out of time! Please, try again.</p>
    </header>
  );
}
